var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"quotes"},_vm._l((_vm.quotes),function(quote,index){return _c('li',{key:index,ref:"quote",refInFor:true},_vm._l((quote),function(word,index){return _c('span',{key:index},[_vm._v(_vm._s(word))])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }